import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContractEntity } from '../../../entities/mdqx/contract.entity';
import { ContractActions, ContractActionTypes } from '../../actions/mdqx/contract.actions';

export interface ContractState extends EntityState<ContractEntity> {
    fetched: boolean;
}

export const CONTRACT_KEY = 'contract';

const adapter = createEntityAdapter<ContractEntity>({
    selectId: contract => contract.Id,
});

const initialState: ContractState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractReducer(state = initialState, action: ContractActions) {
    switch (action.type) {
        case ContractActionTypes.GetContractsResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case ContractActionTypes.PostContractResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case ContractActionTypes.PatchContractResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case ContractActionTypes.DeleteContractResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContracts = selectAll;

export const selectContractsFetched = (state: ContractState) => state.fetched;
